import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useMutation as useInviteUserMutation } from "@faire/web-api--source/api/retailer/invitations/invite/post-hooks";
import { useMutation as useCheckUserAvailabilityMutation } from "@faire/web-api--source/api/user/availability/post-hooks";
import { trackUserInvitationDeactivationFlowInviteExistingAccountUserSubmit } from "@faire/web-api--source/events/userInvitation/submit/deactivationFlowInviteExistingAccountUser";
import { ICheckEmailAddressAndBusinessAvailabilityRequest } from "@faire/web-api--source/indigofair/data/ICheckEmailAddressAndBusinessAvailabilityRequest";
import { IInviteUserRequest } from "@faire/web-api--source/indigofair/data/IInviteUserRequest";
import { IRetailerAccountUserManagement } from "@faire/web-api--source/indigofair/retailer/IRetailerAccountUserManagement";

export const useInviteUser = () => {
  const { strictLocalize } = useStrictLocalization();
  const { mutateAsync: checkUserAvailability } =
    useCheckUserAvailabilityMutation();

  const { mutateAsync: inviteUser } = useInviteUserMutation();
  const { userToken } = useUserStore(["userToken"]);

  const handleInviteUser = async (emailAddress: string) => {
    let error = undefined;
    let accountUserToken = undefined;
    const email = emailAddress.trim();

    try {
      const checkUserAvailabilityResponse = await checkUserAvailability([
        ICheckEmailAddressAndBusinessAvailabilityRequest.build({
          email_address: email,
        }),
      ]);
      const userInviteResponse = await inviteUser([
        IInviteUserRequest.build({
          email: email,
          invited_retailer_role:
            IRetailerAccountUserManagement.Role.CONTRIBUTOR,
          subscribe_to_emails: false,
        }),
      ]);

      accountUserToken =
        userInviteResponse?.retailer_user?.account_user?.account_user_token;

      if (
        accountUserToken &&
        checkUserAvailabilityResponse?.email_address_available === false
      ) {
        trackUserInvitationDeactivationFlowInviteExistingAccountUserSubmit(
          userToken,
          accountUserToken
        );
      }
    } catch (e) {
      error = getWebApiErrorMessage(e, strictLocalize);
    }

    return {
      accountUserToken: accountUserToken ?? "",
      error,
    };
  };

  return {
    handleInviteUser,
  };
};
